export const translations = {
  tr: {
    nav: {
      services: "Hizmetlerimiz",
      about: "Biz Kimiz",
      appointment: "Randevu Al",
      testimonials: "Referanslar",
      guide: "İspanya Rehberi",
      blog: "Blog",
      contact: "İletişim"
    },
    hero: {
      titleStart: "İspanya'da",
      titleEm1: "Yaşam Kurmak",
      titleMid: "ve",
      titleEm2: "Yatırım Yapmak",
      titleEnd: "İsteyenler İçin Tek Adres",
      sub: "Oturum izni alma, gayrimenkul yatırımı, şirket açma ve relocation süreçlerini baştan sona biz yürütüyoruz.",
      cta1: "Randevu Oluştur →",
      cta2: "Hizmetleri İncele",
      stat1: "Başarılı Başvuru",
      stat2: "Onay",
      stat3: "Yıllık Deneyim",
      cardTag: "Aktif Süreç",
      approved: "✓ ONAYLANDI",
      step1: "Başvuru Dosyası Hazırlandı",
      step2: "NIE Numarası Alındı",
      step3: "Banka Hesabı Açıldı",
      step4: "Oturma İzni Başvurusu",
      step5: "Empadronamiento Kaydı"
    },
    trust: {
      label: "Güvenilir Ortaklar"
    },
    about: {
      eyebrow: "Biz Kimiz",
      title: "Nova Iberian'ın Arkasındaki İsim",
      role: "Kurucu & Danışman",
      bio: "Merhaba, ben Can Çağatay Çelikkol. Nova Iberian'ın kurucusuyum. Yıllardır İspanya'da yaşıyor, yatırımcılara ve girişimcilere İspanya'ya taşınma süreçlerinde rehberlik ediyorum. Oturum izni, şirket kurulumu, gayrimenkul yatırımı ve vergi planlaması konularında yüzlerce danışanıma başarıyla yol gösterdim. Amacım, İspanya'daki hayallerinizi gerçeğe dönüştürürken yanınızda olmak. Sosyal medyada İspanya'da yaşam, vize süreçleri ve yatırım fırsatları hakkında içerikler paylaşıyorum. Sorularınız için bana ulaşabilirsiniz!"
    },
    services: {
      eyebrow: "Hizmetlerimiz",
      title: "İspanya'ya adım atmanız için",
      titleEm: "her şey",
      titleEnd: "hazır.",
      sub: "Başvurudan yerleşmeye kadar tüm süreçleri uzman ekibimizle yönetin.",
      showMore: "Diğer Hizmetler",
      showLess: "Daha Az Göster",
      items: [
        { num: "01", title: "Gayrimenkul ve Yatırım Danışmanlığı", desc: "Barselona ve Katalonya'nın en prestijli lokasyonlarında satılık ve kiralık lüks gayrimenkullere erişim sağlayın. Mülk araştırmasından due diligence sürecine, satın alma işlemlerinden yatırım planlamasına kadar uçtan uca danışmanlık.", slug: "gayrimenkul-yatirim-danismanligi" },
        { num: "02", title: "Şirket Kurulumu", desc: "İspanya'da işinizi sağlam temeller üzerine kurun. Autónomo kaydı, Sociedad Limitada (SL) şirket kuruluşu veya yabancı şirket şubesi açılışı dahil tüm süreçlerde yanınızdayız.", slug: "sirket-kurulumu" },
        { num: "03", title: "Oturum İzni", desc: "Dijital Nomad Vizesi, Non-Lucrative Vize, Öğrenci Vizesi, Aile Birleşimi Vizesi ve İspanya vatandaşlığı başvuruları dahil tüm göçmenlik süreçlerinde uzman desteği.", slug: "oturum-izni" },
        { num: "04", title: "Kapsamlı Danışmanlık", desc: "İspanya'ya taşınma sürecinizi bütünsel olarak planlıyoruz. Vize, vergi planlaması, gayrimenkul ve şirket kurulumu gibi süreçleri tek bir çatı altında koordine ediyoruz.", slug: "kapsamli-danismanlik" },
        { num: "05", title: "Vergi Danışmanlığı ve Planlaması", desc: "Beckham Yasası, gelir vergisi beyannameleri, kurumlar vergisi, KDV hizmetleri ve mukim olmayan vergi yükümlülükleri konularında uzman danışmanlık.", slug: "vergi-danismanligi" },
        { num: "06", title: "Pilotaj Eğitimi Danışmanlığı", desc: "İspanya'da pilotaj eğitimi almak isteyenler için kapsamlı danışmanlık. Uçuş okulu seçimi, eğitim programları, lisans süreçleri ve yaşam koşulları hakkında rehberlik.", slug: "pilotaj-egitimi" }
      ]
    },
    info: {
      eyebrow: "İspanya Rehberi",
      title: "Bilmeniz gereken",
      titleEm: "her şey",
      titleEnd: "burada.",
      sub: "İspanya'ya taşınmadan önce en çok sorulan konuları detaylıca inceledik.",
      tabs: ["Vize Türleri", "Yaşam Maliyeti", "Vergi & Maliye", "Şehirler"]
    },
    appointment: {
      eyebrow: "Randevu Al",
      title: "Uzmanımızla",
      titleEm: "tanışın",
      sub: "Durumunuzu değerlendirip yol haritasını birlikte çizelim.",
      pkg0: { name: "🎁 Ücretsiz Keşif Görüşmesi", desc: "Durumunuzu anlayalım.", price: "Ücretsiz", duration: "30 dk · Online" },
      pkg1: { name: "⭐ Kapsamlı Danışmanlık", desc: "Vize stratejisi ve belgeler.", price: "80€", duration: "90 dk · Online veya yüz yüze" },
      pkg2: { name: "💎 Golden Visa Danışmanlığı", desc: "Yatırım ve hukuki danışmanlık.", price: "150€", duration: "120 dk · Yüz yüze" },
      formTitle: "Randevu Oluştur",
      firstName: "Ad",
      lastName: "Soyad",
      email: "E-posta",
      phone: "Telefon",
      notes: "Notlar",
      notesPlaceholder: "İspanya'ya neden taşınmak istiyorsunuz?",
      selectDate: "Tarih Seçin",
      selectTime: "Saat Seçin",
      summary: { pkg: "Paket", date: "Tarih & Saat", total: "Toplam" },
      submit: "Randevu Onayla →"
    },
    testimonials: {
      eyebrow: "Müşteri Yorumları",
      title: "Onlar",
      titleEm: "başardı",
      titleEnd: ", sıra sizde.",
      items: [
        { text: "Non-lucrative vize sürecimde Nova Iberian olmadan asla bu kadar sorunsuz tamamlayamazdım. Artık Barcelona'da yaşıyorum!", name: "Ayşe K.", info: "Barcelona · Non-Lucrative" },
        { text: "Yatırım kararından oturum iznine kadar her aşamada doğru yönlendirme aldım. İspanya'da hem portföyümü hem geleceğimi kurdum.", name: "Serdar Y.", info: "Madrid · Gayrimenkul Yatırımı" },
        { text: "Şirketi kurmak sandığımdan çok daha hızlı oldu. Vergi kaydından banka hesabına kadar hiçbir şeyle bizzat uğraşmadım.", name: "Emre T.", info: "Barcelona · Şirket Kurulumu" },
        { text: "Uzaktan çalışıyorum ve İspanya'da yaşamak istiyordum. Nova Iberian ile tüm süreci rahatlıkla tamamladım. Harika hizmet!", name: "Berk A.", info: "Valencia · Digital Nomad" }
      ]
    },
    faq: {
      eyebrow: "SSS",
      title: "Aklınızdaki",
      titleEm: "sorular",
      items: [
        { q: "Türk pasaportuyla kaç gün vizesiz kalınır?", a: "Schengen kapsamında 6 ayda 90 gün vizesiz. Uzun süreli için ayrı başvuru şart." },
        { q: "NIE numarası nedir?", a: "Yabancı kimlik numaranız. Banka, ev ve iş için zorunlu. Süreci biz yönetiyoruz." },
        { q: "Non-lucrative için ne kadar gelir gerekiyor?", a: "Tek kişi ~€2.400/ay (yıllık €28.800). Her ek aile üyesi için +€7.200/yıl." },
        { q: "Vergi mükellefi olmak zorunda mıyım?", a: "183+ gün kalırsanız evet. Beckham Yasası ile ilk 6 yıl %24 sabit vergi oranından yararlanabilirsiniz." },
        { q: "Çocuklarım okuyabilir mi?", a: "Evet, devlet okulları ücretsiz. Empadronamiento yeterli." }
      ]
    },
    blog: {
      eyebrow: "Blog",
      title: "İspanya'ya dair",
      titleEm: "rehber",
      titleEnd: "yazılar.",
      sub: "Yakında eklenecek içeriklerle İspanya'ya taşınma sürecinizi daha iyi anlayın.",
      comingSoon: "İçerik Hazırlanıyor",
      items: [
        { tag: "Vize", title: "Non-Lucrative Vize: Türkiye'den İspanya'ya En Kısa Yol", date: "Yakında" },
        { tag: "Vergi", title: "Beckham Yasası Nedir? 2026 Güncel Rehber", date: "Yakında" },
        { tag: "Yaşam", title: "Barcelona'da Ev Kiralamak: Adım Adım Rehber", date: "Yakında" }
      ]
    },
    contact: {
      eyebrow: "İletişim",
      title: "Bizimle",
      titleEm: "iletişime",
      titleEnd: "geçin.",
      email: "E-posta",
      phone: "Telefon",
      whatsapp: "WhatsApp",
      offices: "Ofislerimiz",
      officeLocations: "İstanbul, Türkiye · Barcelona, İspanya",
      cta: "Randevu Oluştur →",
      barcelona: { name: "Barcelona", desc: "İspanya Ofisi", sub: "Avrupa operasyonları merkezi" },
      istanbul: { name: "İstanbul", desc: "Türkiye Ofisi", sub: "Başvuru & danışmanlık merkezi" }
    },
    footer: {
      rights: "Tüm hakları saklıdır.",
      privacy: "Gizlilik Politikası",
      terms: "Kullanım Şartları"
    }
  },
  en: {
    nav: {
      services: "Services",
      about: "About Us",
      appointment: "Book Appointment",
      testimonials: "Testimonials",
      guide: "Spain Guide",
      blog: "Blog",
      contact: "Contact"
    },
    hero: {
      titleStart: "The Only Address for Those Who Want to",
      titleEm1: "Build a Life",
      titleMid: "and",
      titleEm2: "Invest",
      titleEnd: "in Spain",
      sub: "We manage residence permits, real estate investments, company formation and relocation processes from start to finish.",
      cta1: "Book Appointment →",
      cta2: "Explore Services",
      stat1: "Successful Applications",
      stat2: "Approval",
      stat3: "Years Experience",
      cardTag: "Active Process",
      approved: "✓ APPROVED",
      step1: "Application File Prepared",
      step2: "NIE Number Obtained",
      step3: "Bank Account Opened",
      step4: "Residence Permit Application",
      step5: "Empadronamiento Registration"
    },
    trust: {
      label: "Trusted Partners"
    },
    about: {
      eyebrow: "About Us",
      title: "The Name Behind Nova Iberian",
      role: "Founder & Consultant",
      bio: "Hello, I'm Can Çağatay Çelikkol, founder of Nova Iberian. I've been living in Spain for years, guiding investors and entrepreneurs through the process of relocating to Spain. I've successfully assisted hundreds of clients with residence permits, company formation, real estate investment, and tax planning. My goal is to be by your side as you turn your Spanish dreams into reality. I share content about living in Spain, visa processes, and investment opportunities on social media. Feel free to reach out with any questions!"
    },
    services: {
      eyebrow: "Our Services",
      title: "Everything is ready for you to",
      titleEm: "step into",
      titleEnd: "Spain.",
      sub: "Manage all processes from application to settlement with our expert team.",
      showMore: "Other Services",
      showLess: "Show Less",
      items: [
        { num: "01", title: "Real Estate & Investment Consulting", desc: "Access luxury properties for sale and rent in Barcelona and Catalonia's most prestigious locations. End-to-end consulting from property research to due diligence, from purchase transactions to investment planning.", slug: "gayrimenkul-yatirim-danismanligi" },
        { num: "02", title: "Company Formation", desc: "Build your business in Spain on solid foundations. We're with you in all processes including Autónomo registration, Sociedad Limitada (SL) company formation or foreign company branch opening.", slug: "sirket-kurulumu" },
        { num: "03", title: "Residence Permit", desc: "Expert support in all immigration processes including Digital Nomad Visa, Non-Lucrative Visa, Student Visa, Family Reunification Visa and Spanish citizenship applications.", slug: "oturum-izni" },
        { num: "04", title: "Comprehensive Consulting", desc: "We plan your relocation to Spain holistically. We coordinate visa, tax planning, real estate and company formation processes under one roof.", slug: "kapsamli-danismanlik" },
        { num: "05", title: "Tax Consulting and Planning", desc: "Expert consulting on Beckham Law, income tax returns, corporate tax, VAT services and non-resident tax obligations.", slug: "vergi-danismanligi" },
        { num: "06", title: "Pilot Training Consulting", desc: "Comprehensive consulting for those who want to receive pilot training in Spain. Guidance on flight school selection, training programs, licensing processes and living conditions.", slug: "pilotaj-egitimi" }
      ]
    },
    info: {
      eyebrow: "Spain Guide",
      title: "Everything you need to",
      titleEm: "know",
      titleEnd: "is here.",
      sub: "We have examined in detail the most frequently asked topics before moving to Spain.",
      tabs: ["Visa Types", "Cost of Living", "Tax & Finance", "Cities"]
    },
    appointment: {
      eyebrow: "Book Appointment",
      title: "Meet with our",
      titleEm: "expert",
      sub: "Let's assess your situation and draw a roadmap together.",
      pkg0: { name: "🎁 Free Discovery Call", desc: "Let us understand your situation.", price: "Free", duration: "30 min · Online" },
      pkg1: { name: "⭐ Comprehensive Consultation", desc: "Visa strategy and documents.", price: "€80", duration: "90 min · Online or in-person" },
      pkg2: { name: "💎 Golden Visa Consultation", desc: "Investment and legal consulting.", price: "€150", duration: "120 min · In-person" },
      formTitle: "Create Appointment",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phone: "Phone",
      notes: "Notes",
      notesPlaceholder: "Why do you want to move to Spain?",
      selectDate: "Select Date",
      selectTime: "Select Time",
      summary: { pkg: "Package", date: "Date & Time", total: "Total" },
      submit: "Confirm Appointment →"
    },
    testimonials: {
      eyebrow: "Client Reviews",
      title: "They",
      titleEm: "succeeded",
      titleEnd: ", now it's your turn.",
      items: [
        { text: "I could never have completed my Non-lucrative visa process so smoothly without Nova Iberian. I now live in Barcelona!", name: "Ayşe K.", info: "Barcelona · Non-Lucrative" },
        { text: "I received the right guidance at every stage from investment decision to residence permit. I built both my portfolio and my future in Spain.", name: "Serdar Y.", info: "Madrid · Real Estate Investment" },
        { text: "Setting up the company was much faster than I thought. I didn't have to deal with anything myself from tax registration to bank account.", name: "Emre T.", info: "Barcelona · Company Formation" },
        { text: "I work remotely and wanted to live in Spain. I completed the entire process comfortably with Nova Iberian. Great service!", name: "Berk A.", info: "Valencia · Digital Nomad" }
      ]
    },
    faq: {
      eyebrow: "FAQ",
      title: "Your",
      titleEm: "questions",
      items: [
        { q: "How many days can you stay visa-free with a Turkish passport?", a: "90 days in 6 months under Schengen. Separate application required for long-term stay." },
        { q: "What is the NIE number?", a: "Your foreign identification number. Required for bank, housing and work. We manage the process." },
        { q: "How much income is required for Non-lucrative?", a: "Single person ~€2,400/month (€28,800/year). +€7,200/year for each additional family member." },
        { q: "Do I have to be a tax resident?", a: "Yes if you stay 183+ days. With Beckham Law, you can benefit from a flat 24% tax rate for the first 6 years." },
        { q: "Can my children go to school?", a: "Yes, public schools are free. Empadronamiento is sufficient." }
      ]
    },
    blog: {
      eyebrow: "Blog",
      title: "Guide",
      titleEm: "articles",
      titleEnd: "about Spain.",
      sub: "Better understand your moving to Spain process with upcoming content.",
      comingSoon: "Content Being Prepared",
      items: [
        { tag: "Visa", title: "Non-Lucrative Visa: The Shortest Route from Turkey to Spain", date: "Coming Soon" },
        { tag: "Tax", title: "What is Beckham Law? 2026 Updated Guide", date: "Coming Soon" },
        { tag: "Life", title: "Renting a House in Barcelona: Step by Step Guide", date: "Coming Soon" }
      ]
    },
    contact: {
      eyebrow: "Contact",
      title: "Get in",
      titleEm: "touch",
      titleEnd: "with us.",
      email: "Email",
      phone: "Phone",
      whatsapp: "WhatsApp",
      offices: "Our Offices",
      officeLocations: "Istanbul, Turkey · Barcelona, Spain",
      cta: "Book Appointment →",
      barcelona: { name: "Barcelona", desc: "Spain Office", sub: "European operations center" },
      istanbul: { name: "Istanbul", desc: "Turkey Office", sub: "Application & consulting center" }
    },
    footer: {
      rights: "All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Use"
    }
  },
  es: {
    nav: {
      services: "Servicios",
      about: "Quiénes Somos",
      appointment: "Reservar Cita",
      testimonials: "Testimonios",
      guide: "Guía de España",
      blog: "Blog",
      contact: "Contacto"
    },
    hero: {
      titleStart: "La Única Dirección para Quienes Quieren",
      titleEm1: "Construir una Vida",
      titleMid: "e",
      titleEm2: "Invertir",
      titleEnd: "en España",
      sub: "Gestionamos permisos de residencia, inversiones inmobiliarias, constitución de empresas y procesos de reubicación de principio a fin.",
      cta1: "Reservar Cita →",
      cta2: "Explorar Servicios",
      stat1: "Solicitudes Exitosas",
      stat2: "Aprobación",
      stat3: "Años Experiencia",
      cardTag: "Proceso Activo",
      approved: "✓ APROBADO",
      step1: "Expediente de Solicitud Preparado",
      step2: "Número NIE Obtenido",
      step3: "Cuenta Bancaria Abierta",
      step4: "Solicitud de Permiso de Residencia",
      step5: "Registro de Empadronamiento"
    },
    trust: {
      label: "Socios de Confianza"
    },
    about: {
      eyebrow: "Quiénes Somos",
      title: "El Nombre Detrás de Nova Iberian",
      role: "Fundador y Consultor",
      bio: "Hola, soy Can Çağatay Çelikkol, fundador de Nova Iberian. Llevo años viviendo en España, guiando a inversores y emprendedores en el proceso de trasladarse a España. He ayudado exitosamente a cientos de clientes con permisos de residencia, constitución de empresas, inversión inmobiliaria y planificación fiscal. Mi objetivo es estar a tu lado mientras conviertes tus sueños españoles en realidad. Comparto contenido sobre vivir en España, procesos de visado y oportunidades de inversión en redes sociales. ¡No dudes en contactarme con cualquier pregunta!"
    },
    services: {
      eyebrow: "Nuestros Servicios",
      title: "Todo está listo para que des tu",
      titleEm: "primer paso",
      titleEnd: "en España.",
      sub: "Gestiona todos los procesos desde la solicitud hasta el asentamiento con nuestro equipo experto.",
      showMore: "Otros Servicios",
      showLess: "Mostrar Menos",
      items: [
        { num: "01", title: "Consultoría Inmobiliaria y de Inversión", desc: "Acceso a propiedades de lujo en venta y alquiler en las ubicaciones más prestigiosas de Barcelona y Cataluña. Consultoría integral desde investigación de propiedades hasta due diligence.", slug: "gayrimenkul-yatirim-danismanligi" },
        { num: "02", title: "Constitución de Empresa", desc: "Construye tu negocio en España sobre bases sólidas. Te acompañamos en todos los procesos incluyendo registro de Autónomo, constitución de Sociedad Limitada (SL) o apertura de sucursal de empresa extranjera.", slug: "sirket-kurulumu" },
        { num: "03", title: "Permiso de Residencia", desc: "Soporte experto en todos los procesos migratorios incluyendo Visa de Nómada Digital, Visa No Lucrativa, Visa de Estudiante, Visa de Reagrupación Familiar y solicitudes de ciudadanía española.", slug: "oturum-izni" },
        { num: "04", title: "Consultoría Integral", desc: "Planificamos tu reubicación a España de manera holística. Coordinamos visa, planificación fiscal, inmuebles y procesos de constitución de empresa bajo un mismo techo.", slug: "kapsamli-danismanlik" },
        { num: "05", title: "Consultoría y Planificación Fiscal", desc: "Consultoría experta en Ley Beckham, declaraciones de impuestos sobre la renta, impuesto de sociedades, servicios de IVA y obligaciones fiscales de no residentes.", slug: "vergi-danismanligi" },
        { num: "06", title: "Consultoría de Formación de Pilotos", desc: "Consultoría integral para quienes desean recibir formación de piloto en España. Orientación sobre selección de escuelas de vuelo, programas de formación, procesos de licencias y condiciones de vida.", slug: "pilotaj-egitimi" }
      ]
    },
    info: {
      eyebrow: "Guía de España",
      title: "Todo lo que necesitas",
      titleEm: "saber",
      titleEnd: "está aquí.",
      sub: "Hemos examinado en detalle los temas más frecuentemente preguntados antes de mudarse a España.",
      tabs: ["Tipos de Visa", "Coste de Vida", "Impuestos y Finanzas", "Ciudades"]
    },
    appointment: {
      eyebrow: "Reservar Cita",
      title: "Reúnete con nuestro",
      titleEm: "experto",
      sub: "Evaluemos tu situación y tracemos una hoja de ruta juntos.",
      pkg0: { name: "🎁 Llamada de Descubrimiento Gratuita", desc: "Déjanos entender tu situación.", price: "Gratis", duration: "30 min · Online" },
      pkg1: { name: "⭐ Consulta Integral", desc: "Estrategia de visa y documentos.", price: "€80", duration: "90 min · Online o presencial" },
      pkg2: { name: "💎 Consulta Golden Visa", desc: "Consultoría de inversión y legal.", price: "€150", duration: "120 min · Presencial" },
      formTitle: "Crear Cita",
      firstName: "Nombre",
      lastName: "Apellido",
      email: "Correo Electrónico",
      phone: "Teléfono",
      notes: "Notas",
      notesPlaceholder: "¿Por qué quieres mudarte a España?",
      selectDate: "Seleccionar Fecha",
      selectTime: "Seleccionar Hora",
      summary: { pkg: "Paquete", date: "Fecha y Hora", total: "Total" },
      submit: "Confirmar Cita →"
    },
    testimonials: {
      eyebrow: "Reseñas de Clientes",
      title: "Ellos",
      titleEm: "lo lograron",
      titleEnd: ", ahora es tu turno.",
      items: [
        { text: "Nunca podría haber completado mi proceso de visa No Lucrativa tan fácilmente sin Nova Iberian. ¡Ahora vivo en Barcelona!", name: "Ayşe K.", info: "Barcelona · No Lucrativa" },
        { text: "Recibí la orientación correcta en cada etapa desde la decisión de inversión hasta el permiso de residencia. Construí tanto mi cartera como mi futuro en España.", name: "Serdar Y.", info: "Madrid · Inversión Inmobiliaria" },
        { text: "Montar la empresa fue mucho más rápido de lo que pensaba. No tuve que lidiar con nada yo mismo desde el registro fiscal hasta la cuenta bancaria.", name: "Emre T.", info: "Barcelona · Constitución de Empresa" },
        { text: "Trabajo de forma remota y quería vivir en España. Completé todo el proceso cómodamente con Nova Iberian. ¡Gran servicio!", name: "Berk A.", info: "Valencia · Nómada Digital" }
      ]
    },
    faq: {
      eyebrow: "Preguntas Frecuentes",
      title: "Tus",
      titleEm: "preguntas",
      items: [
        { q: "¿Cuántos días puedes quedarte sin visa con pasaporte turco?", a: "90 días en 6 meses bajo Schengen. Se requiere solicitud separada para estancia prolongada." },
        { q: "¿Qué es el número NIE?", a: "Tu número de identificación de extranjero. Requerido para banco, vivienda y trabajo. Nosotros gestionamos el proceso." },
        { q: "¿Cuánto ingreso se requiere para No Lucrativa?", a: "Persona sola ~€2.400/mes (€28.800/año). +€7.200/año por cada miembro adicional de la familia." },
        { q: "¿Tengo que ser residente fiscal?", a: "Sí si te quedas más de 183 días. Con la Ley Beckham, puedes beneficiarte de una tasa impositiva fija del 24% durante los primeros 6 años." },
        { q: "¿Pueden mis hijos ir a la escuela?", a: "Sí, las escuelas públicas son gratuitas. El empadronamiento es suficiente." }
      ]
    },
    blog: {
      eyebrow: "Blog",
      title: "Artículos",
      titleEm: "guía",
      titleEnd: "sobre España.",
      sub: "Comprende mejor tu proceso de mudanza a España con el contenido próximo.",
      comingSoon: "Contenido en Preparación",
      items: [
        { tag: "Visa", title: "Visa No Lucrativa: La Ruta Más Corta de Turquía a España", date: "Próximamente" },
        { tag: "Impuestos", title: "¿Qué es la Ley Beckham? Guía Actualizada 2026", date: "Próximamente" },
        { tag: "Vida", title: "Alquilar una Casa en Barcelona: Guía Paso a Paso", date: "Próximamente" }
      ]
    },
    contact: {
      eyebrow: "Contacto",
      title: "Ponte en",
      titleEm: "contacto",
      titleEnd: "con nosotros.",
      email: "Correo Electrónico",
      phone: "Teléfono",
      whatsapp: "WhatsApp",
      offices: "Nuestras Oficinas",
      officeLocations: "Estambul, Turquía · Barcelona, España",
      cta: "Reservar Cita →",
      barcelona: { name: "Barcelona", desc: "Oficina España", sub: "Centro de operaciones europeas" },
      istanbul: { name: "Estambul", desc: "Oficina Turquía", sub: "Centro de solicitudes y consultoría" }
    },
    footer: {
      rights: "Todos los derechos reservados.",
      privacy: "Política de Privacidad",
      terms: "Términos de Uso"
    }
  }
};
